import './Toast.css';
export var flexContainer = '_yjszxq2-3-15-1';
export var icon = '_yjszxq1-3-15-1';
export var root = '_yjszxq0-3-15-1';
export var text = '_yjszxq3-3-15-1';